import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { CollectionsContextProvider } from "./context/collections.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { collections } = usePaintConfiguratorContext();
    return (
        <div
            className={cn(
                "tw:grid tw:grid-cols-2 tw:md:grid-cols-3 tw:lg:grid-cols-4 tw:gap-4 tw:md:gap-6 tw:lg:gap-8"
            )}
        >
            <CollectionsContextProvider collections={collections}>
                {children}
            </CollectionsContextProvider>
        </div>
    );
};

export { Base };
